import { render, staticRenderFns } from "./Prefixes.vue?vue&type=template&id=285e1e56&lang=pug"
import script from "./Prefixes.vue?vue&type=script&lang=js"
export * from "./Prefixes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports